var window_height;
var window_width;
var navbar_initialized = true;
var nav_toggle;

var offCanvas = {
    sidenav: {
        // Sidenav is not visible by default.
        // Change to 1 if necessary
        sidenav_visible: 0
    },
    initSideNav: function initSideNav() {
        if (!navbar_initialized) {
            var $nav = $('#navbar-one');

            // Add the offcanvas class to the navbar if it's not initialized
          //  $nav.addClass('navbar-offcanvas');

            // Clone relevant navbars
            var $navtop = $nav.find('.navbar-top').first().clone(true);
            var $navbar = $nav.find('.navbar-collapse').first().clone(true);

            //rename to avoid having 2 elements with the same ID
            var $orig_navbar = $nav.find('.navbar-collapse').first().attr('id', 'navbar-main1'); 
            ['navHome', 'home-navbar', 'persona-chooser-button'].forEach((id) => {
                $orig_navbar.find('#' + id).attr('id', id + '1');
            })



            // Let's start with some empty vars
            var ul_content = '';
            var top_content = '';

            // Set min-height of the new sidebar to the screen height
            $navbar.css('min-height', window.screen.height);

            // Take the content of .navbar-top
            $navtop.each(function () {
                var navtop_content = $(this).html();
                top_content = top_content + navtop_content;
            });

            // Take the content of .navbar-collapse
            // $orig_navbar.children('div').each(function () { console.log('navbar children each', this);
            //     var nav_content = $(this).html();
            //     ul_content = ul_content + nav_content;
            // });

            if(document.querySelector('#navbar-main1 .container')){
                ul_content = document.querySelector('#navbar-main1 .container').innerHTML;
            }else{
                ul_content = 'nope';
            }

            // Wrap the new content inside an <ul>
            ul_content = '<nav aria-label="Main"><ul class="navbar-nav sidebar-nav">' + ul_content + '</ul></nav>';

            // Insert the html content into our cloned content
            $navbar.html(ul_content);
            $navtop.html(top_content);

            $('.nav-item.nav-title', $navbar).first().remove(); //remove home link
            // Append the navbar to body,
            // and insert the content of the navicons navbar just below the logo/nav-image
            $('body').append($navbar);
            $('.nav-image').after($navtop);


            // Set the toggle-variable to the Bootstrap navbar-toggler button
            var $toggle = $('.navbar-toggler-main');

            // Add/remove classes on toggle and set the visibility of the sidenav,
            // and append the overlay. Also if the user clicks the overlay,
            // the sidebar will close
            $toggle.on('click', function () {

                var hideDropdownOnEscape = (e) => {
                    e.stopPropagation();
                    if(e.keyCode == 27){
                        $navbar.off('keyup', hideDropdownOnEscape);
                       setTimeout(function(){$toggle.click()}, 50);
                    }
                }

                if (offCanvas.sidenav.sidenav_visible === 1) {

                    $('html').removeClass('nav-open');
                    offCanvas.sidenav.sidenav_visible = 0;
                    //$('#overlay').fadeOut(300);
                    setTimeout(function () {
                        $toggle.removeClass('toggled');
                        $toggle.focus();
                        //$('#overlay').remove();
                    }, 50);

                    $navbar.off('keyup', hideDropdownOnEscape);
                } else {

                    setTimeout(function () {
                        $toggle.addClass('toggled');
                        // if we're on mobile, skip this
                        // if($('.navbar-super').css('display') !== 'none'){ 
                            // $navbar.find('.navbar-nav.sidebar-nav').find('a').get(1).focus();
                        // }
                    }, 50);

                    $('html').addClass('nav-open');
                    offCanvas.sidenav.sidenav_visible = 1;

                    $navbar.on('keyup', hideDropdownOnEscape);
                }

            });
            // Set navbar to initialized
            navbar_initialized = true;
        }
    }
};

$(document).ready(function () {

    window_width = $(window).width();
    window_height = $(window).height();

    nav_toggle = $('nav').hasClass('navbar-offcanvas') ? true : false;

    // Responsive checks
    if (window_width < 992 || nav_toggle) {
        offCanvas.initSideNav();
    }

    // Close the sidebar if the user clicks a link or a dropdown-item,
    // and close the sidebar
    $('.nav-link:not(.dropdown-toggle), .dropdown-item').on('click', function () {
        var $toggle = $('.navbar-toggler');

        $('html').removeClass('nav-open');
        offCanvas.sidenav.sidenav_visible = 0;
        setTimeout(function () {
            $toggle.removeClass('toggled');
        }, 300);
    });

});

$(window).resize(function () {

    // More responsive checks if the user resize the browser
    if ($(window).width() < 992) {
        offCanvas.initSideNav();
    }

    if ($(window).width() > 992 && !nav_toggle) {
        $('nav').removeClass('navbar-offcanvas');
        offCanvas.sidenav.sidenav_visible = 1;
        navbar_initialized = false;
    }

});
